"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _knotchincWebReactComponents = _interopRequireDefault(require("@bit/knotchinc.web-react-components.background"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getChildrenArray = function getChildrenArray(c) {
  return c.length >= 1 ? c.filter(function (component) {
    return component || false;
  }) : [c];
};
/**
 * Give a tabName prop to the children and it will used as a grouping for tabs.
 */

/**
 *
 * @param  tabName
 * @param {*} children
 */


var getChild = function getChild(tabName, children) {
  var childrenArray = getChildrenArray(children);
  var child = childrenArray.filter(function (i) {
    return i && i.props.tabName === tabName;
  });

  if (child && child[0]) {
    return child[0];
  }

  return null;
};

var ComponentTabContainer = /*#__PURE__*/function (_Component) {
  _inherits(ComponentTabContainer, _Component);

  var _super = _createSuper(ComponentTabContainer);

  function ComponentTabContainer(props) {
    var _this;

    _classCallCheck(this, ComponentTabContainer);

    _this = _super.call(this, props);

    var tabs = _this.createTabs();

    _this.state = {
      tabs: tabs,
      current: tabs[0]
    };
    return _this;
  }

  _createClass(ComponentTabContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevChildren = getChildrenArray(prevProps.children);
      var currentChildren = getChildrenArray(this.props.children);

      if (prevChildren.length !== currentChildren.length) {
        this.setState({
          tabs: this.createTabs()
        });
      }
    }
  }, {
    key: "createTabs",
    value: function createTabs() {
      return getChildrenArray(this.props.children).map(function (component) {
        return component.props.tabName;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          style = _this$props.style;
      var _this$state = this.state,
          tabs = _this$state.tabs,
          current = _this$state.current;
      var displayedChild = children;
      var onlyChild = !Array.isArray(children);

      if (children.length > 1) {
        displayedChild = getChild(current, children);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: style
      }, /*#__PURE__*/_react["default"].createElement(_styled.StyledTabContainer, null, tabs.map(function (tab) {
        // TODO: Re-enable tab metrics
        var currentChild = getChild(tab, children);
        var tabIcon = currentChild && currentChild.props.tabIcon; // const tabMetric = currentChild && currentChild.props.tabMetric;

        var tabMetric = null;
        return /*#__PURE__*/_react["default"].createElement(_styled.StyledTab, {
          key: "tab_".concat(tab),
          onClick: function onClick() {
            return _this2.setState({
              current: tab
            });
          },
          selected: current === tab,
          maxWidth: 100 / tabs.length,
          onlyChild: onlyChild
        }, /*#__PURE__*/_react["default"].createElement(_styled.StyledTabContentContainer, null, tabIcon ? /*#__PURE__*/_react["default"].createElement(_styled.TabIconContainer, null, /*#__PURE__*/_react["default"].createElement(_knotchincWebReactComponents["default"], {
          url: tabIcon,
          opacity: 0,
          color: "transparent"
        })) : null, /*#__PURE__*/_react["default"].createElement(_styled.TabTextContainer, null, tab, /*#__PURE__*/_react["default"].createElement(_styled.StyledSecondary, null, tabMetric || null))));
      })), /*#__PURE__*/_react["default"].createElement(_styled.StyledComponentContainer, null, displayedChild));
    }
  }]);

  return ComponentTabContainer;
}(_react.Component);

var _default = ComponentTabContainer;
exports["default"] = _default;

//# sourceMappingURL=ComponentTabContainer.js.map